import React from 'react';

import { ModalType } from '../Content/MarketingCopy';
import CtaButtonModalBody from '../CtaButtonModalBody';
import ModalHeader, { ModalHeaderProps } from '../common/modalHeader';

type CtaButtonModalProps = ModalHeaderProps & {
  buttonText: string;
  customUrl?: string;
  offerLink?: string;
};

const CtaButtonModal: React.FC<CtaButtonModalProps> = ({
  buttonText,
  customUrl,
  disclosure,
  highlight,
  modalType,
  offerLink,
  subtitle,
  title,
}) => {
  return (
    <div className="flex w-full flex-wrap content-center items-center justify-center px-24 py-72 sm:px-64 sm:py-64 md:justify-between md:px-48 md:pb-80 md:pt-80">
      <ModalHeader highlight={highlight} title={title} subtitle={subtitle} />
      <div className="w-full md:w-[380px]">
        <CtaButtonModalBody
          buttonText={buttonText}
          destinationUrl={modalType === ModalType.CustomUrl ? customUrl : offerLink}
          disclosure={disclosure}
        />
      </div>
    </div>
  );
};

export default CtaButtonModal;
